import { useLocation, useNavigate } from "react-router-dom";
import { Button, Stack, Typography, Card, CardContent, CardActions, Box, Divider } from "@mui/material";
import { useEffect } from "react";
import { useTranslations } from "hooks";
import { getTranslation } from "common";
import FlowentiLogo from "../../../image/Logo.svg"; //# use this cause is without background
import EmailImage from "../../../image/EmailSent.png";

interface LocationState {
    email?: string;
}

const ForgotPasswordConfirm = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const translations = useTranslations();

    const email = (state as LocationState)?.email;

    useEffect(() => {
        if (!email) {
            navigate("/forgotpassword", { replace: true });
        }
    }, [email, navigate]);

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            minHeight="100vh"
            bgcolor="background.default"
            padding={2}
        >
            {/* LOGO */}
            <Box display="flex" alignItems="center">
                          <Box mb={2} component="img" src={FlowentiLogo} alt="email-sent" style={{ height: 60 }} />
                <Typography variant="h2">Flowenti</Typography>
            </Box>
            {/* CARD */}
            <Card
                elevation={6}
                sx={{
                    width: { xs: "100%", sm: 480, md: 600 },
                    padding: 4,
                    textAlign: "center",
                    bgcolor: "background.paper",
                }}
            >
                <Box mb={2} component="img" src={EmailImage} alt="email-sent" style={{ height: 60 }} />
                <CardContent>
                    <Stack spacing={3}>
                        <Typography variant="h5" fontWeight={600}>
                            {getTranslation(translations, "forgotpassword.confirm.title")}
                        </Typography>

                        {/* DIVIDER */}
                        <Divider />

                        <Typography variant="body1">
                            {getTranslation(translations, "forgotpassword.confirm.text")}
                        </Typography>

                        {email && (
                            <Typography variant="subtitle2" color="text.secondary">
                                {getTranslation(translations, "forgotpassword.confirm.email")}:{" "}
                                <strong>{email}</strong>
                            </Typography>
                        )}
                    </Stack>
                </CardContent>

                <CardActions sx={{ justifyContent: "center", marginTop: 2 }}>
                    <Button
                        variant="contained"
                        onClick={() => navigate("/login")}
                        id="back-to-login"
                    >
                        {getTranslation(translations, "forgotpassword.confirm.backtologin")}
                    </Button>
                </CardActions>
            </Card>
        </Box>

    );
};

export default ForgotPasswordConfirm;
